import React from 'react'
import { createRoot } from 'react-dom/client'
import registerServiceWorker from 'serviceWorkerRegistration'

import varna from 'utils/varna'

import Index from './index2'

varna.init()
const root = createRoot(document.getElementById('root'))
root.render(<Index />)

registerServiceWorker()
